import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import { User } from "../model.ts"

export interface AuthState {
  user: User | null
  token: string | null
  weightable: string | null
  isAuthenticated: boolean
}

const initialState: AuthState = {
  user: null,
  token: null,
  weightable: null,
  isAuthenticated: false,
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (
      state,
      action: PayloadAction<{
        user: User
        token: string
        weightable: string | null
      }>
    ) => {
      state.user = action.payload.user
      state.token = action.payload.token
      state.weightable = action.payload.weightable
      state.isAuthenticated = true

      localStorage.setItem("user", JSON.stringify(action.payload.user))
      localStorage.setItem("token", action.payload.token)
      localStorage.setItem("weightable", action.payload.weightable || "")
    },

    restoreSession: (state) => {
      const user = localStorage.getItem("user")
      const token = localStorage.getItem("token")
      const weightable = localStorage.getItem("weightable")

      if (user && token) {
        state.user = JSON.parse(user)
        state.token = token
        state.weightable = weightable
        state.isAuthenticated = true
      }
    },

    logout: (state) => {
      state.user = null
      state.token = null
      state.weightable = null
      state.isAuthenticated = false

      localStorage.removeItem("user")
      localStorage.removeItem("token")
      localStorage.removeItem("weightable")
    },
  },
})

// Action creators
export const { setAuth, restoreSession, logout } = authSlice.actions

export default authSlice.reducer
